var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderDevelop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 898 895",
    width: 898,
    height: 895,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5097610-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #e0e0e0 } \r\n\t\t.s1 { fill: #ffffff } \r\n\t\t.s2 { fill: #f5f5f5 } \r\n\t\t.s3 { fill: #fafafa } \r\n\t\t.s4 { fill: #ebebeb } \r\n\t\t.s5 { fill: #263238 } \r\n\t\t.s6 { fill: #455a64 } \r\n\t\t.s7 { fill: #ff725e } \r\n\t\t.s8 { fill: #000000 } \r\n\t\t.s9 { fill: none;stroke: #fbfbfb;stroke-width: 2 } \r\n\t\t.s10 { fill: #ffbe9d } \r\n\t\t.s11 { fill: #eb996e } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m860.2 25.2v161.9h-232.6l-8.4-160.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m851.8 26.3v160.5h-232.6v-160.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m852.9 187.9h-234.8v-162.7h234.8zm-232.6-2.2h230.4v-158.2h-230.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m826.6 46.3v120.5h-182.2v-120.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m826.6 46.3q0 0-0.9 0-0.9 0-2.6 0-3.5 0-10 0.1c-8.8 0-21.5 0.1-37.6 0.1-32.1 0.1-77.6 0.2-131.1 0.3l0.5-0.5c0 36.8 0.1 77.6 0.1 120.5l-0.6-0.5c68.7 0 132.1 0.1 182.2 0.1l-0.5 0.4c0.1-36.7 0.2-66.7 0.3-87.7 0-10.5 0.1-18.6 0.1-24.3q0-4.1 0-6.3c0.1-1.5 0.1-2.2 0.1-2.2q0 0 0 2.1 0.1 2.2 0.1 6.3c0 5.6 0.1 13.7 0.1 24.1 0.1 21 0.1 51.2 0.2 88v0.5h-0.4c-50.1 0-113.5 0.1-182.2 0.1h-0.6v-0.6c0-42.9 0.1-83.7 0.1-120.5v-0.6h0.5c53.7 0.1 99.3 0.2 131.5 0.3 16 0.1 28.7 0.1 37.4 0.1q6.5 0.1 9.9 0.1 1.6 0 2.5 0 0.9 0.1 0.9 0.1z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m619.2 25.9c0.1-0.1 1.6 0.8 4 2.6 2.4 1.7 5.6 4.1 9.1 6.9 3.5 2.8 6.6 5.5 8.8 7.5 2.1 1.9 3.4 3.2 3.3 3.4-0.2 0.2-5.8-4.4-12.8-10-7-5.6-12.6-10.2-12.4-10.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m851.8 26.3c0.2 0.3-5.3 4.9-12.3 10.4-6.9 5.5-12.7 9.8-12.9 9.6-0.2-0.3 5.3-5 12.2-10.5 7-5.5 12.8-9.7 13-9.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m851.6 186.8q-13-10.5-25.9-21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m825.7 165.8c0.2-0.3 6.1 4.2 13.3 10 7.1 5.8 12.8 10.8 12.6 11-0.2 0.2-6.2-4.3-13.3-10.1-7.2-5.8-12.8-10.7-12.6-10.9z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m619.2 186.8c-0.2-0.3 5.2-4.9 12.1-10.3 6.9-5.5 12.6-9.7 12.8-9.4 0.2 0.2-5.2 4.8-12.1 10.3-6.9 5.4-12.6 9.6-12.8 9.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m796 83.8v40.4h-114.6v-40.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m691.4 294.5h206.2v598.5h-206.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m580.7 294.5h225.7v598.5h-225.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m654.7 749v-3.6h68.9v3.6c0 2.4-1.9 4.3-4.3 4.3h-60.3c-2.4 0-4.3-1.9-4.3-4.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m590.7 747.7q0 2.3 0.1 6.5c0 5.7 0 14.1 0.1 24.8 0 21.4 0.1 52.3 0.2 90l-0.4-0.4c54.5-0.1 124.7-0.1 201.1-0.2h0.2l-0.6 0.6c0-43.7 0-85.4 0-123.4l0.6 0.6c-59.1-0.2-109.3-0.3-144.8-0.4-17.8-0.1-31.9-0.2-41.6-0.2q-7.2-0.1-11.1-0.1-1.8 0-2.8 0-1-0.1-1-0.1 0 0 0.9 0 1 0 2.8 0 3.8 0 11-0.1c9.6 0 23.7 0 41.4-0.1 35.6 0 86-0.1 145.2-0.1h0.5v0.5c0 38 0 79.7 0 123.4v0.6h-0.5-0.2c-76.4-0.1-146.6-0.1-201.1-0.1h-0.5v-0.5c0.1-37.9 0.2-68.8 0.2-90.3 0.1-10.7 0.1-19 0.2-24.7q0-4.2 0-6.4 0-2.2 0.1-2.2c0 0 0 0.8 0 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m657.4 775.6h59.9v16.2h-59.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m657.4 605v-3.6h68.9v3.6c0 2.4-1.9 4.3-4.3 4.3h-60.3c-2.4 0-4.3-1.9-4.3-4.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m591.3 603.7q0 2.2 0 6.5c0 5.7 0.1 14.1 0.1 24.8 0.1 21.4 0.2 52.2 0.3 90l-0.5-0.5c54.6 0 124.8 0 201.2-0.1h0.1l-0.6 0.6c0.1-43.7 0.1-85.4 0.1-123.4l0.5 0.5c-59-0.1-109.2-0.3-144.8-0.3-17.8-0.1-31.8-0.2-41.5-0.2q-7.3-0.1-11.1-0.1-1.9 0-2.9 0-1-0.1-1-0.1 0 0 0.9 0 1 0 2.9 0 3.8-0.1 10.9-0.1c9.7 0 23.7 0 41.5-0.1 35.6 0 86-0.1 145.1-0.1h0.5v0.5c0.1 38 0.1 79.7 0.1 123.4v0.6h-0.6-0.1c-76.4-0.1-146.6-0.1-201.2-0.2h-0.4v-0.4c0.1-37.9 0.1-68.8 0.2-90.3 0.1-10.7 0.1-19 0.1-24.7q0.1-4.2 0.1-6.4 0-2.2 0-2.2c0 0 0 0.8 0.1 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m661.9 630.7h59.9v16.1h-59.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m654.8 314.4v-3.6h68.9v3.6c0 2.4-1.9 4.3-4.3 4.3h-60.3c-2.4 0-4.3-1.9-4.3-4.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m590.8 313.1q0 2.2 0.1 6.5c0 5.7 0 14 0.1 24.8 0 21.4 0.1 52.2 0.2 90l-0.4-0.5c54.5 0 124.8-0.1 201.2-0.1h0.1l-0.6 0.6c0-43.8 0-85.5 0-123.4l0.6 0.5c-59-0.1-109.3-0.3-144.8-0.4-17.8 0-31.9-0.1-41.6-0.1q-7.2-0.1-11.1-0.1-1.8 0-2.8-0.1-1 0-1 0 0 0 0.9 0 1 0 2.8-0.1 3.8 0 11 0c9.6 0 23.7-0.1 41.4-0.1 35.6 0 86-0.1 145.2-0.1h0.5v0.5c0 37.9 0 79.6 0 123.4v0.6h-0.5-0.1c-76.4-0.1-146.7-0.1-201.2-0.2h-0.5v-0.4c0.1-37.9 0.2-68.8 0.3-90.3 0-10.7 0-19 0.1-24.7q0-4.2 0-6.4 0.1-2.2 0.1-2.2c0 0 0 0.8 0 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m660.4 337.1h59.9v16.2h-59.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m654.8 459.6v-3.6h68.9v3.6c0 2.4-1.9 4.3-4.3 4.3h-60.3c-2.4 0-4.3-1.9-4.3-4.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m590.8 458.3q0 2.3 0.1 6.5c0 5.7 0 14.1 0.1 24.8 0 21.4 0.1 52.3 0.2 90l-0.4-0.4c54.5-0.1 124.8-0.1 201.2-0.2h0.1l-0.6 0.6c0-43.7 0-85.4 0-123.4l0.6 0.6c-59-0.2-109.3-0.3-144.8-0.4-17.8-0.1-31.9-0.2-41.6-0.2q-7.2-0.1-11.1-0.1-1.8 0-2.8 0-1-0.1-1-0.1 0 0 0.9 0 1 0 2.8 0 3.8 0 11-0.1c9.6 0 23.7 0 41.4-0.1 35.6 0 86-0.1 145.2-0.1h0.5v0.5c0 38 0 79.7 0 123.4v0.6h-0.5-0.1c-76.4-0.1-146.7-0.1-201.2-0.1h-0.5v-0.5c0.1-37.9 0.2-68.8 0.3-90.3 0-10.7 0-19 0.1-24.7q0-4.2 0-6.4 0.1-2.2 0.1-2.2c0 0 0 0.8 0 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m660.4 482.4h59.9v16.1h-59.9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m263.3 214.6h-216.2v-193.4h216.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m263.3 214.6c0 0-0.1-1.3-0.1-3.6q0-3.6 0-10.4c-0.1-9.1-0.1-22.3-0.2-39.3 0-33.7-0.1-82-0.2-140.1l0.5 0.4c-62.3 0.1-136.6 0.1-216.2 0.1l0.6-0.5c-0.1 70.3-0.1 136.5-0.1 193.4l-0.5-0.6c64.5 0.2 118.5 0.2 156.3 0.3 19 0.1 33.9 0.1 44.1 0.1q7.7 0.1 11.7 0.1 2 0 3 0 1.1 0.1 1.1 0.1 0 0-1 0-1 0-3 0-4 0-11.5 0.1c-10.2 0-25.1 0.1-44 0.1-38 0.1-92.1 0.2-156.7 0.3h-0.5v-0.5c0-56.9-0.1-123.1-0.1-193.4v-0.6h0.6c79.6 0 153.9 0 216.2 0.1h0.5v0.5c-0.2 58.2-0.2 106.6-0.3 140.5-0.1 16.8-0.1 30.1-0.1 39.1q-0.1 6.7-0.1 10.3 0 3.5 0 3.5z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m130 55.5c0 0.3-11.4 0.6-25.4 0.6-14.1 0-25.4-0.3-25.4-0.6 0-0.3 11.3-0.6 25.4-0.6 14 0 25.4 0.3 25.4 0.6z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m221.6 70c0 0.4-31.3 0.6-69.8 0.6-38.6 0-69.9-0.2-69.9-0.6 0-0.3 31.3-0.5 69.9-0.5 38.5 0 69.8 0.2 69.8 0.5z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m88.6 103.7h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m111.1 103.7h-9.2v-9.1h9.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m133.9 103.3h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m155.9 103.7h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m178.3 103.7h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m200.7 103.7h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m223.1 103.7h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m88.6 123.1h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m111.1 123.1h-9.2v-9.1h9.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m133.5 123.1h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m155.9 123.1h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m178.3 123.1h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m201.1 122.7h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m223.1 123.1h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m88.6 142.5h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m111.5 142.1h-9.1v-9.2h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m133.5 142.5h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m155.9 142.5h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m178.3 142.5h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m200.7 142.5h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m223.1 142.5h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m88.6 161.8h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m111.1 161.8h-9.2v-9.1h9.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m133.5 161.8h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m156.3 161.4h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m178.3 161.8h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m200.7 161.8h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m223.1 161.8h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m88.6 181.2h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m111.1 181.2h-9.2v-9.1h9.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m133.5 181.2h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m155.9 181.2h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m178.3 181.2h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m201.1 180.8h-9.1v-9.1h9.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m223.1 181.2h-9.1v-9.1h9.1z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m463.9 359.4l-74.6 28.1-18.9-50.3 74.6-28z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m445.4 309.7q0.1 0-0.4 0.9-0.5 1-1.4 2.6c-1.3 2.3-3 5.6-5.2 9.5-4.5 8.1-10.7 19.1-17.6 31.3l-0.1 0.3-0.3-0.1q-0.3-0.1-0.7-0.2c-13.5-4.4-25.6-8.4-34.6-11.4-4.3-1.4-7.9-2.6-10.4-3.5q-1.8-0.6-2.8-1-1-0.3-1-0.4 0 0 1 0.3 1.1 0.3 2.9 0.9c2.5 0.8 6.1 1.9 10.5 3.3 8.9 2.8 21.1 6.7 34.6 11.1q0.4 0.1 0.7 0.2l-0.4 0.2c6.9-12.2 13.2-23.2 17.7-31.2 2.3-3.9 4.1-7.1 5.5-9.4q0.9-1.6 1.5-2.6 0.5-0.8 0.5-0.8z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m389.8 388c-0.2-0.1 2.8-9.1 6.7-20.1 3.9-11 7.3-19.9 7.4-19.9 0.2 0.1-2.8 9.1-6.7 20.1-3.9 11.1-7.2 20-7.4 19.9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m428.5 338.1c0.1-0.2 8.2 4.6 18.1 10.6 9.9 6 17.9 11.1 17.8 11.2-0.1 0.2-8.3-4.5-18.2-10.6-9.9-6-17.8-11-17.7-11.2z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m541.5 150.5q2.9-1.8 6.1-2.7l1.3-6 10.2-0.2 1.5 6q3.2 0.8 6.1 2.5l5.2-3.4 7.3 7.1-3.2 5.2q1.8 2.9 2.7 6.1l6 1.3 0.2 10.2-6 1.5q-0.8 3.2-2.4 6.2l3.4 5.1-7.1 7.3-5.3-3.1q-2.9 1.7-6.1 2.6l-1.2 6-10.2 0.2-1.5-6q-3.2-0.8-6.2-2.4l-5.2 3.4-7.3-7.1 3.2-5.3q-1.8-2.9-2.7-6.1l-6-1.2-0.2-10.2 6-1.5q0.8-3.2 2.4-6.2l-3.3-5.2 7.1-7.3zm5.4 13.6c-4.2 4.3-4.1 11.3 0.3 15.5 4.3 4.2 11.2 4 15.4-0.3 4.2-4.4 4.1-11.3-0.2-15.5-4.4-4.2-11.3-4.1-15.5 0.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m547 164.1c0 0 0.5-0.8 2-1.8 1.4-1 4-2 7.1-1.7 1.6 0.2 3.3 0.7 4.9 1.7 1.5 1.1 3 2.5 3.9 4.5q0.7 1.4 1 3c0.2 1.1 0.2 2.3 0.1 3.4-0.3 2.3-1.4 4.5-3.1 6.3-1.7 1.8-3.9 2.9-6.2 3.3-1.1 0.2-2.2 0.2-3.3 0q-1.7-0.2-3.1-0.9c-2-0.8-3.5-2.2-4.6-3.7-1.1-1.6-1.7-3.3-1.9-4.8-0.4-3.2 0.5-5.7 1.5-7.2 0.9-1.5 1.7-2.1 1.7-2.1 0 0-0.7 0.7-1.5 2.2-0.9 1.5-1.7 4-1.2 7 0.2 1.5 0.8 3.1 1.8 4.6 1.1 1.4 2.6 2.7 4.4 3.5q1.4 0.6 2.9 0.8c1.1 0.2 2.2 0.2 3.2 0 2.2-0.4 4.3-1.5 5.9-3.1 1.6-1.7 2.6-3.8 2.9-6 0.1-1.1 0.1-2.1-0.1-3.2q-0.2-1.5-0.9-2.9c-0.8-1.8-2.2-3.2-3.7-4.2-1.5-1-3.1-1.6-4.6-1.7-3.1-0.4-5.5 0.5-7 1.4-1.4 0.9-2.1 1.6-2.1 1.6z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m541.5 150.5q0 0-0.3-0.2-0.4-0.2-1-0.6-1.4-0.8-4-2.3h0.1c-1.8 1.9-4.1 4.3-7 7.4v-0.2q1.6 2.3 3.4 5.1l0.1 0.1-0.1 0.1c-1 1.8-1.8 3.9-2.4 6.1v0.2h-0.1c-1.9 0.4-3.9 1-6 1.5l0.1-0.2q0.1 4.8 0.2 10.2l-0.1-0.3c1.8 0.4 3.9 0.8 6 1.3h0.1l0.1 0.1c0.5 2 1.4 4.1 2.6 6.1l0.1 0.1-0.1 0.2c-1 1.6-2.1 3.4-3.2 5.2v-0.3c2.3 2.2 4.8 4.6 7.3 7.1l-0.3-0.1c1.6-1 3.3-2.2 5.1-3.4l0.2-0.1 0.1 0.1c1.8 1 3.9 1.9 6.2 2.4l0.1 0.1 0.1 0.2c0.4 1.8 0.9 3.9 1.4 5.9l-0.3-0.2c3.3 0 6.7-0.1 10.2-0.2l-0.3 0.3c0.4-1.9 0.9-4 1.3-6.1v-0.1l0.2-0.1c2-0.6 4.1-1.4 6-2.6l0.2-0.1 0.2 0.1q2.6 1.6 5.2 3.2h-0.3q3.6-3.7 7-7.3v0.4q-1.7-2.6-3.4-5.2l-0.1-0.1 0.1-0.2c1.1-1.9 1.9-4 2.4-6.1l0.1-0.2h0.2q3-0.8 5.9-1.5l-0.2 0.3q-0.1-5.2-0.2-10.2l0.3 0.3q-3.1-0.7-6.1-1.3h-0.1l-0.1-0.2c-0.6-2.2-1.5-4.2-2.6-6l-0.1-0.2 0.1-0.1q1.7-2.7 3.2-5.3l0.1 0.3q-3.9-3.7-7.4-7.1l0.3 0.1q-2.7 1.7-5.1 3.3l-0.1 0.1-0.2-0.1c-2-1.1-4.1-1.9-6.1-2.4h-0.1v-0.1c-0.6-2.2-1-4.2-1.5-6l0.2 0.1c-4 0.1-7.3 0.1-10.2 0.1l0.1-0.1c-0.5 2.4-0.9 4.4-1.3 6.1-2.2 0.6-3.7 1.3-4.7 1.8q-0.7 0.4-1.1 0.6-0.4 0.2-0.4 0.2 0 0 0.4-0.2 0.3-0.3 1-0.7c1-0.5 2.5-1.2 4.7-1.9l-0.1 0.1c0.4-1.6 0.8-3.6 1.2-6l0.1-0.1h0.1c2.9-0.1 6.2-0.2 10.2-0.3h0.1l0.1 0.2c0.4 1.8 0.9 3.8 1.5 6l-0.2-0.2c2.1 0.5 4.2 1.3 6.3 2.5h-0.3q2.5-1.6 5.2-3.4l0.1-0.1 0.2 0.1q3.5 3.3 7.3 7.1l0.2 0.1-0.1 0.2q-1.6 2.6-3.2 5.3v-0.3c1.1 1.9 2 3.9 2.7 6.2l-0.2-0.2q2.9 0.6 6 1.2l0.2 0.1v0.2q0.1 5 0.2 10.2v0.2l-0.2 0.1q-3 0.7-6 1.5l0.2-0.3c-0.5 2.2-1.3 4.3-2.4 6.3l-0.1-0.3q1.7 2.5 3.4 5.1l0.2 0.2-0.2 0.2q-3.5 3.6-7.1 7.4l-0.2 0.1-0.2-0.1q-2.6-1.6-5.3-3.2h0.4c-2 1.2-4.1 2.1-6.2 2.7l0.2-0.2c-0.4 2-0.8 4.1-1.2 6l-0.1 0.2-0.2 0.1c-3.6 0-7 0.1-10.2 0.1h-0.3v-0.2c-0.6-2.1-1.1-4.1-1.5-6l0.2 0.2c-2.3-0.5-4.4-1.4-6.3-2.4l0.4-0.1c-1.8 1.2-3.6 2.4-5.2 3.4l-0.2 0.1-0.2-0.1c-2.5-2.5-5-4.9-7.3-7.1l-0.2-0.2 0.2-0.2c1.1-1.8 2.2-3.6 3.2-5.2v0.3c-1.3-2.1-2.1-4.2-2.7-6.2l0.2 0.2c-2.1-0.5-4.2-0.9-6-1.3h-0.2v-0.2q-0.1-5.4-0.2-10.2v-0.2l0.2-0.1c2.1-0.5 4.1-1 6-1.4l-0.2 0.1c0.6-2.3 1.5-4.4 2.5-6.2v0.2q-1.8-2.8-3.4-5.2v-0.1l0.1-0.1c2.9-2.9 5.3-5.4 7.1-7.3h0.1q2.5 1.6 3.9 2.4 0.6 0.4 1 0.7 0.3 0.2 0.3 0.2z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m47 872.6c-3.7-3.1-11.8-13-5.5-24.6 2.3-4.2 7.2-6.3 11.6-8.1 4.4-1.9 9.1-3.5 12.7-6.6 7-5.9 8.9-15.7 13.4-23.5 5.3-9 15.1-15.8 25.5-15.3 11.9 0.5 21.8 10.3 26.3 21.3 4.5 11.1 4.7 23.4 4.8 35.3 0 6.7-0.3 14.1-5.1 18.6-4.5 4.1-11.2 4.1-17.3 4q-32.5-1-65-2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m171.2 694.9l-5.9 50.1h0.1l-0.7 5-14.8 126.5c-1.1 9.3-8.3 16.5-17.3 17.9q-2.1 0.4-4.2 0.4c0 0-76.2 0-76.2 0l-0.8 0.2q0-0.1 0-0.2-1.8-0.1-3.5-0.4c-0.5-0.1-1-0.3-1.5-0.4q-0.3-0.1-0.6-0.2c-7.5-2.1-13.3-8.3-14.6-16.3l-30.8-183.5h170.9zm-27.6 62.8h-20.3l-1.8 53.3h17.5zm-2.8 53.3h15.1l6.2-53.3h-16.8zm-22.9 59l1.6-46.2h-25.3l1.1 46.2zm-46.4 0h22.1l-1.1-46.2h-24.5zm-5.3-46.3h-24.3c2.8 17.5 5.3 33.8 7.3 46.3h20.6zm25.9-12.8l-1.2-53.3h-28.2l4.2 53.3zm27.6 0l1.8-53.3h-29l1.3 53.3zm2.1-66l1.7-49.4h-32.5l1.2 49.4zm-32.6-49.4h-31.5l3.8 49.4h28.9zm-33.3 0h-34.7c0.6 2.8 1.8 10.3 5 30.2 0.9 5.8 2 12.3 3 19.1h30.6zm-24.7 62.1c1.9 11.8 3.8 24.3 5.8 36.9q1.3 8.2 2.6 16.4h25.2l-4.1-53.3zm-1.7 0h-17.1l9 53.3h16.5c-2.9-18.5-5.8-36.9-8.4-53.3zm-6 66l7.8 46.3h15.8c-2.2-14.5-4.7-30.3-7.2-46.3zm110.1 46.3l3.9-46.3h-16.8l-1.6 46.3zm10.7-125.1l4.2-49.3h-23.5l-1.7 49.3zm-142.3-49.3l8.3 49.3h17.2c-4.2-26.3-7.3-45.8-8-49.3zm151.9 128.1h-14.7l-3.9 46.3h13.2zm15-128.1h-18.7l-4.3 49.3h17.2z"
  })))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m867 893c0 0.3-183.1 0.5-409 0.5-225.9 0-409-0.2-409-0.5 0-0.3 183.1-0.5 409-0.5 225.9 0 409 0.2 409 0.5z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m683.4 429.9c0 0 16.3-18.8 25.4-31.5 9.2-12.8 21.2-39.2 21.2-39.2 0 0 4.2-3.1-4.7 24.1-8.9 27.2-32.5 54.4-32.5 54.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m688.1 363.4c0.7-1.3 2.8-0.6 2.5 0.9-1.4 9.6-4.5 32-4.4 46.5 0.2 18.9 0 26.2 0 26.2h-9.8c0 0 1.7-39 3.9-50.9 1.6-8.4 4.9-17.6 7.8-22.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m675.4 434.6c0 0-7.6-18.1-9.7-29.8-2-11.8 0.7-17.9 3.1-30.3 0.8-4.6 4.3-11.8 5.4-13.9 1.2-2.1 4.4-1.3 4.5 1.1 0 3.2-0.3 7.8-1.3 13.9-2.1 12.5-3.6 21.9-2.8 28.9 1.9 16.3 8.1 29.3 8.1 29.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m673.9 436.3h-8.9c0 0-20-57.8-24.6-69.3-4.7-11.5-3.6-21.6-2.9-22.6 0.7-1.1 6.8 17.9 8.6 26.2 1.8 8.3 27.8 64 27.8 64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m686.2 431.5c0.5-0.3 1.1-0.9 2-1.6 1.6-1.4 4-3.5 6.8-6.2 5.6-5.5 12.5-13.9 18.6-24.2 6.1-10.3 10.3-20.3 13-27.7 1.3-3.6 2.3-6.7 3-8.7q0.5-1.5 0.8-2.4 0.3-0.9 0.3-0.9 0 0.1-0.2 0.9-0.2 0.8-0.7 2.4c-0.6 2.1-1.6 5.2-2.9 8.9-2.6 7.4-6.7 17.5-12.8 27.8-6.1 10.3-13.2 18.7-18.8 24.1-2.9 2.8-5.3 4.8-7 6.2-0.9 0.7-1.6 1.2-2 1.5q-0.7 0.5-0.7 0.5-0.1 0 0.6-0.6z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m682.7 403.7c0.1-1 0.2-2.6 0.3-4.5 0.4-3.7 0.9-9 1.9-14.7 0.9-5.7 2-10.9 2.8-14.5 0.5-1.9 0.9-3.4 1.2-4.4 0.3-1 0.4-1.6 0.5-1.6 0 0-0.1 0.6-0.3 1.6q-0.4 1.8-1 4.4c-0.8 3.7-1.8 8.9-2.7 14.6-0.9 5.7-1.6 10.9-2 14.7q-0.3 2.7-0.4 4.5c-0.2 1-0.2 1.6-0.3 1.6 0 0 0-0.6 0-1.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m676.4 360.9q-0.2 0.8-0.6 2.1c-0.3 0.9-0.7 2-1.1 3.3-0.3 1.4-0.8 2.8-1.1 4.5q-0.3 1.3-0.6 2.6c-0.2 0.9-0.4 1.9-0.6 2.9-0.4 2-0.6 4.1-0.9 6.3-0.5 4.5-0.8 9.5-0.6 14.7 0.2 5.3 0.8 10.2 1.6 14.7 0.5 2.2 0.9 4.3 1.4 6.2 0.3 1 0.5 2 0.8 2.8q0.4 1.4 0.8 2.6c0.4 1.7 1 3.1 1.5 4.4 0.4 1.3 0.8 2.4 1.2 3.2q0.5 1.3 0.8 2.1 0.3 0.7 0.3 0.7 0 0-0.4-0.7-0.3-0.7-0.9-2c-0.4-0.8-0.9-1.9-1.3-3.2-0.5-1.3-1.1-2.7-1.6-4.4q-0.4-1.2-0.8-2.5c-0.3-0.9-0.5-1.9-0.8-2.9-0.6-1.9-1-4-1.5-6.2-0.8-4.5-1.4-9.5-1.6-14.7-0.2-5.3 0.1-10.3 0.6-14.8 0.3-2.3 0.5-4.4 1-6.4 0.2-1 0.3-1.9 0.5-2.9q0.4-1.3 0.7-2.6c0.4-1.7 0.9-3.1 1.2-4.4 0.4-1.4 0.8-2.5 1.2-3.4q0.4-1.2 0.7-2 0.3-0.7 0.3-0.7 0.1 0-0.2 0.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m637.9 345.7q0 0.3 0.1 0.7c0.2 0.7 0.4 1.6 0.6 2.8 0.6 2.4 1.5 5.8 2.8 10 1.4 4.1 3.2 9 5.3 14.4 2.1 5.4 4.6 11.2 6.9 17.5 2.3 6.3 4.1 12.4 5.8 17.9 1.6 5.6 3.2 10.5 4.7 14.7 1.4 4.1 2.8 7.3 3.9 9.5 0.5 1.1 0.9 2 1.2 2.6q0.2 0.4 0.3 0.6 0.1 0.3 0.1 0.3 0 0-0.1-0.2-0.2-0.3-0.4-0.7c-0.3-0.5-0.8-1.4-1.3-2.5-1.1-2.2-2.6-5.4-4.1-9.5-1.5-4.1-3.1-9.1-4.8-14.6-1.7-5.6-3.5-11.7-5.8-17.9-2.3-6.3-4.8-12.1-6.9-17.5-2.1-5.4-3.8-10.3-5.1-14.5-1.3-4.2-2.2-7.7-2.7-10.1-0.2-1.2-0.4-2.1-0.5-2.7q0-0.5-0.1-0.8 0-0.2 0-0.2 0 0 0.1 0.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m717.8 333.2c1.6-1.6 4.3 0 3.7 2.3-0.7 2.2-1.8 5.1-3.3 8.3-3.6 7.6-14 34.8-19 49.7-4.9 15-11.8 42.8-11.8 42.8l-10.4-1.7c0 0 9.5-45.7 18.9-62.2 7.5-13.3 15-32.4 21.9-39.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m696 404.2q-0.4 1.4-1 3.6c-0.9 3-2 7.1-3.2 11.8-1.1 4.6-2.2 8.7-3 11.8q-0.6 2.2-0.9 3.6c-0.3 0.9-0.4 1.3-0.5 1.3 0 0 0.1-0.5 0.3-1.3q0.3-1.5 0.7-3.7c0.7-3 1.7-7.2 2.9-11.9 1.2-4.6 2.4-8.8 3.3-11.8 0.5-1.5 0.9-2.7 1.2-3.5 0.4-0.8 0.5-1.2 0.6-1.2 0 0-0.1 0.5-0.4 1.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m682.2 435.2q0-0.3 0-0.8c0.1-0.8 0.2-1.9 0.4-3.2 0.3-2.8 0.9-6.8 2-11.6 1.1-4.9 2.7-10.6 4.8-16.8 2.1-6.3 4.8-13 7.9-19.9 6.1-13.9 12.3-26.2 16.5-35.2 2.1-4.5 3.7-8.2 4.8-10.8q0.8-1.8 1.3-2.9 0.2-0.4 0.3-0.7 0.1-0.3 0.1-0.3 0.1 0 0 0.3-0.1 0.3-0.3 0.8c-0.3 0.6-0.7 1.6-1.2 2.9-1 2.6-2.6 6.3-4.7 10.8-4 9.1-10.2 21.4-16.3 35.3-3.1 6.9-5.8 13.6-7.9 19.8-2.2 6.2-3.8 11.9-4.9 16.8-1.1 4.8-1.8 8.7-2.2 11.5-0.2 1.4-0.3 2.4-0.4 3.2q-0.1 0.5-0.2 0.8 0 0.3 0 0.3 0 0 0-0.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m677.1 432.8c0.1-1.1 0.3-2.8 0.6-4.8 0.7-4.1 1.7-9.7 3.3-15.8 1.6-6.1 3.4-11.5 4.9-15.4 0.7-1.9 1.3-3.5 1.8-4.5 0.4-1.1 0.7-1.7 0.7-1.7 0.1 0-0.1 0.7-0.5 1.7q-0.7 1.8-1.7 4.6c-1.3 3.9-3.1 9.3-4.7 15.4-1.5 6.1-2.6 11.7-3.4 15.8q-0.5 2.9-0.8 4.8c-0.2 1.1-0.3 1.7-0.3 1.7-0.1 0 0-0.6 0.1-1.8z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m655.5 433.1h40.8v49.8h-40.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m655.5 433.1h40.8v49.8h-40.8z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m668.5 433.1h36.3v49.8h-36.3z"
  })))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Mail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m345.5 74.1l-75.9 24.3-16.4-51.2 75.9-24.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m329.6 23.5q0 0-0.5 0.9-0.6 0.9-1.6 2.5c-1.3 2.3-3.3 5.4-5.7 9.3-4.9 7.8-11.6 18.5-19.1 30.3l-0.1 0.3-0.3-0.1q-0.3-0.1-0.7-0.3c-13.2-5.1-25.2-9.7-33.9-13-4.3-1.7-7.8-3.1-10.3-4.1q-1.7-0.7-2.8-1.1-0.9-0.4-0.9-0.4 0-0.1 1 0.3 1.1 0.4 2.8 1c2.5 0.9 6 2.2 10.4 3.8 8.7 3.3 20.7 7.8 34 12.9q0.3 0.1 0.7 0.2l-0.5 0.2c7.6-11.9 14.3-22.5 19.3-30.3 2.5-3.8 4.5-6.9 5.9-9.1q1-1.6 1.6-2.5 0.6-0.8 0.7-0.8z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m270.1 98.9c-0.2-0.1 3.2-8.9 7.7-19.7 4.4-10.8 8.2-19.6 8.4-19.5 0.2 0.1-3.3 8.9-7.7 19.8-4.5 10.8-8.3 19.5-8.4 19.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m311.2 51c0.1-0.2 8 5 17.6 11.5 9.6 6.5 17.2 12 17.1 12.1-0.1 0.2-7.9-5-17.5-11.5-9.6-6.5-17.3-11.9-17.2-12.1z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m664.3 133.9l-56.4-24c-3.9-1.6-5.8-6.1-4.1-10l33.1-78.2c1.7-3.9 6.2-5.7 10.1-4.1l35.8 15.2 15.6 40.3-24 56.7c-1.7 3.9-6.2 5.7-10.1 4.1z"
  })))))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m698.4 73.1l-21.2-8.9c-3.6-1.6-5.3-5.8-3.7-9.4l9.3-22z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.2
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m677.2 64.2l21.2 8.9c0 0-2.3 5.5-2.5 5.9-0.2 0.5-17-10.5-19.6-12.1q-0.3-0.3-0.6-0.5c-5.3-4.3-2.8-9.5-2.8-9.5-0.9 4.8 4.3 7.3 4.3 7.3z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m698.4 73.1l-21.2-8.9c-3.6-1.6-5.3-5.8-3.7-9.4l9.3-22z"
  }))))))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m669.1 51.9c-0.1 0.3-6.1-2-13.3-5-7.2-3.1-12.9-5.8-12.8-6.1 0.1-0.3 6 2 13.3 5.1 7.2 3 12.9 5.7 12.8 6z"
  }))))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m680.7 71.5c-0.1 0.3-9.8-3.6-21.7-8.6-11.9-5-21.4-9.3-21.3-9.6 0.1-0.3 9.8 3.5 21.7 8.6 11.9 5 21.4 9.3 21.3 9.6z"
  }))))))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m680.2 83.5c-0.1 0.3-10.7-3.9-23.7-9.4-12.9-5.5-23.3-10.2-23.2-10.4 0.1-0.3 10.7 3.9 23.7 9.4 12.9 5.5 23.3 10.1 23.2 10.4z"
  }))))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m676 93.3c-0.1 0.3-10.7-3.9-23.6-9.4-13-5.5-23.4-10.2-23.3-10.4 0.2-0.3 10.8 3.9 23.7 9.4 12.9 5.5 23.3 10.1 23.2 10.4z"
  }))))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m671.9 103.1c-0.1 0.3-10.7-3.9-23.7-9.4-12.9-5.5-23.3-10.2-23.2-10.4 0.1-0.3 10.7 3.9 23.7 9.4 12.9 5.5 23.3 10.1 23.2 10.4z"
  }))))))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m667.7 112.9c-0.1 0.3-10.7-3.9-23.6-9.4-13-5.5-23.4-10.2-23.3-10.4 0.2-0.3 10.8 3.9 23.7 9.4 12.9 5.5 23.3 10.1 23.2 10.4z"
  }))))))))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m549.1 75.7c0 41.3-33.4 74.7-74.7 74.7-41.2 0-74.7-33.4-74.7-74.7 0-41.2 33.5-74.7 74.7-74.7 41.3 0 74.7 33.5 74.7 74.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m549.1 75.7q0 0-0.1-1.2-0.1-1.2-0.2-3.5-0.1-1.2-0.2-2.6c-0.1-1-0.3-2-0.4-3.1-0.4-2.3-0.7-4.9-1.6-7.7-1.3-5.8-4-12.6-8.3-19.9-4.3-7.1-10.5-14.7-18.9-21-8.4-6.4-19-11.7-31.3-13.9-3-0.4-6.1-1.1-9.3-1.1-1.6 0-3.3-0.2-4.9-0.2q-2.4 0.2-4.9 0.3c-0.8 0-1.7 0-2.5 0.1l-2.5 0.4c-1.6 0.3-3.3 0.5-4.9 0.8-3.3 0.9-6.7 1.6-9.9 2.9-3.4 1.1-6.5 2.8-9.7 4.3-1.6 0.8-3.1 1.8-4.6 2.8-0.8 0.4-1.6 0.9-2.3 1.4l-2.2 1.6c-3 2.1-5.7 4.7-8.4 7.2-2.5 2.8-5.1 5.5-7.3 8.6l-1.7 2.3-1.5 2.4-1.5 2.5q-0.8 1.2-1.4 2.5-1.2 2.6-2.5 5.2-1 2.8-2 5.5c-2.4 7.5-3.7 15.4-3.8 23.4 0.1 8.1 1.4 16 3.8 23.4q1 2.8 2 5.5 1.3 2.7 2.5 5.3 0.6 1.3 1.4 2.5l1.5 2.5 1.5 2.4 1.7 2.3c2.1 3.1 4.8 5.8 7.3 8.6 2.7 2.5 5.4 5.1 8.4 7.1l2.2 1.7c0.7 0.5 1.5 0.9 2.3 1.4 1.5 0.9 3 1.9 4.6 2.8 3.2 1.5 6.3 3.2 9.7 4.2 3.2 1.4 6.6 2.1 9.9 2.9 1.6 0.4 3.3 0.6 5 0.9l2.4 0.3c0.9 0.1 1.7 0.1 2.5 0.2q2.5 0.1 4.9 0.3c1.6 0 3.3-0.2 4.9-0.2 3.2 0 6.3-0.7 9.3-1.1 12.3-2.2 22.9-7.6 31.3-13.9 8.4-6.4 14.6-13.9 18.9-21.1 4.3-7.2 7-14 8.3-19.8 0.9-2.8 1.2-5.4 1.6-7.7 0.1-1.1 0.3-2.1 0.4-3.1q0.1-1.4 0.2-2.6 0.1-2.3 0.2-3.5 0.1-1.3 0.1-1.3 0 0 0 1.3 0 1.2-0.1 3.5-0.1 1.2-0.1 2.6c-0.1 1-0.3 2-0.4 3.2-0.4 2.2-0.7 4.9-1.5 7.7-1.3 5.8-3.9 12.7-8.2 20-4.3 7.3-10.5 14.9-18.9 21.4-8.5 6.4-19.2 11.9-31.6 14.1-3.1 0.5-6.2 1.1-9.5 1.2-1.6 0-3.2 0.2-4.9 0.2q-2.5-0.2-5-0.3c-0.8 0-1.6 0-2.5-0.1l-2.5-0.4c-1.7-0.3-3.4-0.5-5-0.8-3.4-0.9-6.8-1.6-10.1-3-3.3-1-6.5-2.7-9.8-4.3-1.6-0.8-3.1-1.8-4.7-2.7-0.7-0.5-1.6-1-2.3-1.5l-2.2-1.7c-3.1-2.1-5.7-4.7-8.5-7.2-2.6-2.8-5.2-5.5-7.4-8.7l-1.8-2.3-1.5-2.5-1.5-2.5q-0.8-1.2-1.4-2.6-1.3-2.6-2.5-5.3-1.1-2.7-2.1-5.5c-2.4-7.6-3.8-15.6-3.9-23.8 0.1-8.1 1.5-16.1 3.9-23.7q1-2.8 2.1-5.6 1.2-2.6 2.5-5.3 0.6-1.3 1.4-2.5l1.5-2.5 1.5-2.5 1.8-2.3c2.2-3.2 4.8-5.9 7.4-8.7 2.8-2.5 5.4-5.2 8.5-7.3l2.2-1.6c0.7-0.6 1.6-1 2.3-1.5 1.6-0.9 3.1-1.9 4.7-2.8 3.3-1.5 6.5-3.2 9.8-4.3 3.3-1.3 6.7-2 10.1-2.9 1.6-0.3 3.3-0.5 5-0.8l2.5-0.4c0.9-0.1 1.7-0.1 2.5-0.1q2.5-0.2 5-0.3c1.7 0 3.3 0.2 4.9 0.2 3.3 0.1 6.4 0.7 9.5 1.1 12.4 2.3 23.1 7.8 31.6 14.2 8.4 6.5 14.6 14.1 18.9 21.4 4.3 7.3 6.9 14.1 8.2 20 0.8 2.8 1.1 5.4 1.5 7.7 0.1 1.1 0.3 2.2 0.4 3.2q0 1.4 0.1 2.6 0.1 2.3 0.1 3.5 0 1.2 0 1.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m509.9 73.6c0 0.1-1.1 0.4-3 0.9-2.2 0.5-5 1.2-8.4 2-7 1.6-16.8 3.8-27.8 6.2l-0.6 0.2v-0.7q0-1 0-2.1c0-11.7 0-22.3 0.1-30 0.1-3.7 0.2-6.8 0.2-9.1 0.1-2.1 0.1-3.3 0.2-3.3 0.1 0 0.1 1.2 0.2 3.3 0 2.3 0.1 5.4 0.2 9.1 0.1 7.7 0.1 18.3 0.1 30q0 1.1 0 2.1l-0.6-0.5c10.9-2.4 20.8-4.5 27.9-5.9 3.4-0.7 6.2-1.3 8.4-1.7 2-0.4 3.1-0.5 3.1-0.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m554.5 106.5q-0.1 0 0.3-1.2c0.2-0.8 0.7-1.9 1.1-3.4 0.9-3 2.1-7.3 2.9-12.8 1.8-10.9 1.8-26.7-3.9-42.7-5.7-16-15.7-28.2-24-35.5-4.1-3.7-7.8-6.4-10.4-8.1-1.2-0.9-2.3-1.5-3-1.9q-1-0.7-1-0.7 0-0.1 1.1 0.5c0.7 0.4 1.8 0.9 3.2 1.8 2.6 1.6 6.4 4.2 10.6 7.8 8.4 7.3 18.7 19.6 24.5 35.8 5.7 16.2 5.6 32.2 3.7 43.1-1 5.5-2.3 9.9-3.3 12.8-0.5 1.5-1 2.6-1.3 3.4q-0.5 1.1-0.5 1.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m568.8 69.8c-0.2 0-0.3-3-0.9-7.8-0.6-4.7-1.8-11.2-4.2-18.2-2.3-6.9-5.4-12.8-7.8-16.9-2.4-4.1-4.2-6.5-4.1-6.6 0.1-0.1 0.6 0.5 1.4 1.5 0.9 1.1 2 2.7 3.3 4.7 2.6 4.1 5.8 10 8.2 17 2.4 7 3.5 13.6 4 18.5 0.2 2.4 0.2 4.3 0.2 5.7 0 1.3 0 2.1-0.1 2.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m399.9 32.5q0 0-0.5 1.1c-0.4 0.8-1 1.8-1.7 3.2-1.4 2.8-3.2 6.9-4.9 12.2-3.5 10.5-6 26.1-2.9 42.8 3.1 16.7 11.1 30.3 18 38.8 3.5 4.4 6.7 7.6 9 9.7 1.1 1 2.1 1.8 2.7 2.4q0.9 0.8 0.9 0.8-0.1 0.1-1.1-0.7c-0.6-0.5-1.6-1.2-2.8-2.2-2.3-2.1-5.6-5.2-9.2-9.5-7.2-8.5-15.4-22.2-18.5-39.2-3.1-16.9-0.5-32.6 3.2-43.1 1.8-5.3 3.8-9.4 5.3-12.2 0.7-1.4 1.4-2.4 1.8-3.1q0.6-1 0.7-1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m379.9 66.5c0.2 0-0.2 3-0.4 7.8-0.1 4.8 0 11.4 1.3 18.6 1.2 7.2 3.3 13.5 5 18 1.8 4.4 3.1 7.1 3 7.2-0.1 0-0.5-0.6-1.2-1.8-0.6-1.2-1.5-2.9-2.5-5.1-1.9-4.5-4.1-10.8-5.4-18.1-1.2-7.3-1.3-14.1-0.9-18.9 0.2-2.4 0.4-4.3 0.6-5.7 0.2-1.3 0.4-2 0.5-2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.3 88.1c-2.8-0.6-5.1-1.1-5.1-1.1 0 0 2.3 0.4 5.1 1 2.8 0.5 5.1 1 5.1 1.1 0 0-2.3-0.4-5.1-1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m529 106.9c-2.4-1.5-4.4-2.7-4.4-2.7 0 0 2 1.2 4.5 2.6 2.5 1.5 4.5 2.7 4.4 2.7 0 0-2-1.1-4.5-2.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m516.1 122.3c-1.9-2.2-3.4-3.9-3.4-4 0 0 1.6 1.8 3.4 4 1.9 2.2 3.4 3.9 3.4 4-0.1 0-1.6-1.8-3.4-4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m498.8 132.7c-1.1-2.6-1.9-4.8-1.9-4.8 0 0 0.9 2.1 2 4.8 1 2.7 1.9 4.8 1.8 4.9 0 0-0.9-2.2-1.9-4.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m479.1 137c-0.2-2.9-0.2-5.2-0.2-5.2 0 0 0.1 2.3 0.3 5.2 0.1 2.8 0.2 5.2 0.2 5.2-0.1 0-0.2-2.4-0.3-5.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m459 134.5c0.8-2.7 1.5-4.9 1.5-4.9 0.1 0-0.6 2.2-1.4 5-0.8 2.7-1.4 5-1.5 5 0 0 0.6-2.3 1.4-5.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m440.9 125.8c1.6-2.4 3-4.3 3-4.2 0 0-1.3 1.9-3 4.2-1.6 2.4-3 4.3-3 4.3 0-0.1 1.3-2 3-4.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m426.6 111.6c2.3-1.7 4.2-3.1 4.2-3 0 0-1.9 1.4-4.2 3.1-2.3 1.6-4.2 3-4.2 3-0.1-0.1 1.8-1.4 4.2-3.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m417.6 93.5c2.8-0.8 5-1.5 5-1.5 0 0.1-2.2 0.8-5 1.6-2.7 0.8-5 1.5-5 1.5 0-0.1 2.3-0.8 5-1.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m415 73.5c2.9 0.1 5.2 0.2 5.2 0.2 0 0.1-2.3 0-5.2-0.1-2.9-0.1-5.2-0.2-5.2-0.2 0-0.1 2.3 0 5.2 0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m419.1 53.7c2.7 1.1 4.8 1.9 4.8 1.9 0 0.1-2.2-0.8-4.9-1.8-2.7-1-4.8-1.9-4.8-1.9 0 0 2.2 0.8 4.9 1.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m429.3 36.3c2.2 1.9 4 3.4 4 3.4 0 0.1-1.8-1.4-4.1-3.3-2.2-1.8-3.9-3.3-3.9-3.4 0 0 1.8 1.5 4 3.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m444.6 23.3c1.5 2.4 2.7 4.4 2.7 4.4 0 0.1-1.3-1.9-2.7-4.4-1.5-2.5-2.7-4.5-2.7-4.5 0 0 1.3 2 2.7 4.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m463.4 15.8c0.6 2.8 1.1 5.1 1 5.1 0 0-0.5-2.2-1.1-5.1-0.6-2.8-1.1-5.1-1.1-5.1 0.1 0 0.6 2.3 1.2 5.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m483.5 14.9c-0.3 2.9-0.6 5.2-0.6 5.2-0.1 0 0.2-2.4 0.5-5.2 0.4-2.9 0.7-5.2 0.7-5.2 0 0-0.2 2.3-0.6 5.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m502.9 20.6c-1.2 2.5-2.3 4.6-2.3 4.6 0 0 1-2.1 2.2-4.7 1.3-2.6 2.3-4.7 2.3-4.7 0 0-1 2.2-2.2 4.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m519.4 32.2c-2.1 2-3.7 3.7-3.7 3.7-0.1-0.1 1.6-1.7 3.6-3.8 2-2 3.7-3.7 3.7-3.6 0 0-1.6 1.7-3.6 3.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m531.2 48.5c-2.6 1.3-4.7 2.3-4.7 2.3 0 0 2-1.1 4.6-2.3 2.6-1.3 4.7-2.3 4.7-2.3 0 0-2.1 1.1-4.6 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m537 67.8c-2.8 0.4-5.1 0.7-5.1 0.7 0-0.1 2.3-0.4 5.1-0.8 2.9-0.3 5.2-0.6 5.2-0.6 0 0-2.3 0.4-5.2 0.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.1 60.9c0.2 0.2-1.7 4.5-4.3 9.8q-0.1 0.1-0.1 0.2l-0.4 0.8-0.5-0.7c-3.2-4.8-5.5-8.8-5.3-9 0.3-0.1 3 3.6 6.2 8.4h-0.9q0-0.1 0.1-0.2c2.6-5.2 4.9-9.4 5.2-9.3z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m628.8 250.7c0 11.5-9.3 20.8-20.8 20.8h-100.5v23.4l-24.6-23.4h-110c-11.5 0-20.8-9.3-20.8-20.8 0-11.5 9.3-20.9 20.8-20.9h235.1c11.5 0 20.8 9.4 20.8 20.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m608 229.8q0 0 0.8 0c0.5 0.1 1.2 0 2.2 0.2 2 0.3 5 1 8.4 3.1 3.2 2.1 6.9 5.7 8.6 11.2 1.8 5.4 1.4 12.7-2.9 18.7-2.1 3-5.2 5.6-9 7.2-1.9 0.7-3.9 1.2-6 1.5-2.2 0.2-4.3 0.1-6.5 0.1-8.7 0-18.2 0-28.3 0.1-20.2 0-43 0-67.8 0l0.4-0.4c0.1 7.3 0.1 15.3 0.1 23.4v1.2l-0.8-0.8c-7.8-7.4-16.1-15.3-24.7-23.5l0.4 0.2c-29.1 0-60.8 0-93.5 0q-8.2 0-16.3 0c-5.6 0-11.1-2.2-15-6-3.9-3.8-6.3-9.1-6.5-14.4-0.2-5.4 1.7-10.8 5.1-14.8 3.5-4 8.4-6.7 13.5-7.3 2.6-0.3 5.1-0.1 7.7-0.2q3.7 0 7.4 0 14.9 0.1 29.2 0.1c37.9 0 72 0 100.7 0.1 28.6 0 51.8 0.1 67.9 0.1 8 0.1 14.2 0.1 18.5 0.1q3.1 0.1 4.8 0.1 1.6 0 1.6 0 0 0.1-1.6 0.1-1.7 0-4.8 0c-4.3 0.1-10.5 0.1-18.5 0.1-16.1 0.1-39.3 0.1-67.9 0.2-28.7 0-62.8 0.1-100.7 0.1q-14.3 0-29.2 0-3.7 0-7.4 0c-2.5 0.1-5.1-0.1-7.5 0.2-4.9 0.6-9.6 3.1-12.9 7-3.3 3.8-5.1 8.9-4.8 14 0.1 5.1 2.4 10.2 6.2 13.8 3.7 3.6 8.9 5.7 14.2 5.7q8.1 0 16.3 0c32.7 0 64.4 0 93.5 0h0.2l0.1 0.1c8.5 8.2 16.8 16.1 24.6 23.5l-0.8 0.3c0-8.1 0-16.1 0-23.4v-0.5h0.5c24.8 0.1 47.6 0.1 67.8 0.1 10.1 0 19.6 0 28.3 0.1 2.2 0 4.4 0 6.4-0.1 2.1-0.3 4-0.7 5.9-1.5 3.6-1.5 6.7-4 8.7-6.9 4.3-5.9 4.7-13 3-18.3-1.6-5.4-5.2-9-8.4-11.1-3.2-2.1-6.2-2.8-8.2-3.1-2-0.3-3-0.3-3-0.4z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m475.7 265.4h-102.9c-8.1 0-14.7-6.6-14.7-14.7 0-8.2 6.6-14.7 14.7-14.7h102.9c8.2 0 14.8 6.5 14.8 14.7 0 8.1-6.6 14.7-14.8 14.7z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m484.4 208.4l-3.5 10.6h-2.7l-2.3-7.2-2.4 7.2h-2.6l-3.5-10.6h2.5l2.4 7.5 2.5-7.5h2.3l2.4 7.5 2.5-7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m484.9 213.7c0-3.2 2.5-5.5 5.9-5.5 3.3 0 5.8 2.3 5.8 5.5 0 3.2-2.5 5.5-5.8 5.5-3.4 0-5.9-2.3-5.9-5.5zm9.2 0c0-2-1.4-3.4-3.3-3.4-1.9 0-3.4 1.4-3.4 3.4 0 2 1.5 3.4 3.4 3.4 1.9 0 3.3-1.4 3.3-3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m505.2 219l-2-2.9h-2.3v2.9h-2.5v-10.6h4.6c2.9 0 4.7 1.5 4.7 3.8 0 1.6-0.8 2.8-2.2 3.4l2.4 3.4zm-2.4-8.6h-2v3.7h2c1.6 0 2.3-0.7 2.3-1.9 0-1.1-0.7-1.8-2.3-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m513.5 214.8l-1.5 1.5v2.7h-2.4v-10.6h2.4v4.9l4.8-4.9h2.7l-4.4 4.7 4.7 5.9h-2.9z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m581 254.6h-2.9l-0.8 3.8h-2.1l0.7-3.8h-8.6l0.3-1.6 9.9-10.2h2.5l-9.5 9.9h5.9l0.7-3.4h2l-0.6 3.4h2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m587.4 244.8l-1.2 4.2h1.5c3.9 0 5.7 1.7 5.7 4.2 0 3.2-2.6 5.4-6.6 5.4-2.3 0-4.3-0.8-5.4-2l1.2-1.7c0.8 1 2.4 1.7 4.4 1.7 2.7 0 4.2-1.2 4.2-3.2 0-1.5-1.1-2.4-3.9-2.4h-3.8l2.4-8.2h8.8l-0.4 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m596 247.8c0-2.7 1.7-5.1 4.3-5.1 1.9 0 3.1 1.3 3.1 3.4 0 2.7-1.6 5.1-4.2 5.1-1.9 0-3.2-1.3-3.2-3.4zm13.8-5h1.8l-13.6 15.6h-1.8zm-7.9 3.4c0-1.5-0.6-2.3-1.8-2.3-1.8 0-2.6 2-2.6 3.7 0 1.5 0.6 2.3 1.8 2.3 1.8 0 2.6-2 2.6-3.7zm2.5 8.9c0-2.7 1.6-5.1 4.3-5.1 1.8 0 3.1 1.3 3.1 3.4 0 2.7-1.6 5.1-4.3 5.1-1.9 0-3.1-1.3-3.1-3.4zm5.9-1.6c0-1.4-0.7-2.2-1.8-2.2-1.8 0-2.7 2-2.7 3.7 0 1.5 0.7 2.2 1.8 2.2 1.8 0 2.7-2 2.7-3.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m385.7 236l-8.9 29.4h-9.6l9.6-29.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m409.3 236l-9 29.4h-9.5l9.5-29.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m432.9 236l-9 29.4h-9.5l9.5-29.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m456.4 236l-9 29.4h-9.5l9.5-29.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m480 236l-9 29.4h-9.5l9.5-29.4z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m317.9 650.6c0 0-51.7 24.6-100.5 24.6-52.8 0-103.4-22.8-103.4-22.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m222.9 871.9h-20.9v-219.1h20.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: ""
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m305.3 871.9h-185.7v-12.8h185.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m142.3 876.1c0 7.9-6.3 14.2-14.1 14.2-7.9 0-14.2-6.3-14.2-14.2 0-7.8 6.3-14.1 14.2-14.1 7.8 0 14.1 6.3 14.1 14.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m224.8 876.1c0 7.9-6.3 14.2-14.1 14.2-7.9 0-14.2-6.3-14.2-14.2 0-7.8 6.3-14.1 14.2-14.1 7.8 0 14.1 6.3 14.1 14.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m320.4 876.1c0 7.9-6.3 14.2-14.2 14.2-7.8 0-14.1-6.3-14.1-14.2 0-7.8 6.3-14.1 14.1-14.1 7.9 0 14.2 6.3 14.2 14.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m217.4 743.4h-28.5v-11.7h28.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m194.1 751.7h-10.3v-28.3h10.3z"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m193.9 624.5h-108.1v-282.5c0-12.8 10.4-23.2 23.2-23.2h84.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m109.8 619.8c-0.3 0-0.6-66.3-0.6-148.1 0-81.8 0.3-148.1 0.6-148.1 0.3 0 0.5 66.3 0.5 148.1 0 81.8-0.2 148.1-0.5 148.1z"
  })))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m353.5 657.1h-251.8c-8.7 0-15.9-7.1-15.9-15.9v-17.3h267.7z"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m287.6 148.9l2.7 0.4c26.9 4.5 45.9 28.9 43.6 56-2.2 25.3-4.8 53.2-7.2 66.6-5 27.7-33.4 27.4-33.4 27.4-0.2 0.8-0.9 7.7-1.8 16.1-1.8 17.5-10.9 41.3-36.9 41.7-29.9-1.7-30.8-29.8-28.9-48.6l11.6-110.6c2.3-29.1 21.2-52.1 50.3-49z"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m292.5 306.4c-28.1-2.1-33.5-23.8-33.5-23.8 16.6 14.8 34.3 16.7 34.3 16.7z"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m285.2 212.4c-0.6 0.5-3.6-2.4-8.3-3-4.6-0.6-8.3 1.4-8.8 0.8-0.2-0.3 0.5-1.3 2.1-2.2 1.6-0.9 4.2-1.7 7.1-1.3 2.9 0.3 5.2 1.7 6.5 3 1.3 1.3 1.7 2.4 1.4 2.7z"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m284.7 223.1c-0.2 2-2.1 3.4-4.2 3.1-2.1-0.2-3.6-2-3.3-4 0.2-2 2.1-3.4 4.2-3.2 2.1 0.3 3.6 2.1 3.3 4.1z"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m293.9 245.9c0-0.2 2.7-0.2 7.1-0.1 1.1 0.1 2.2 0 2.5-0.7 0.4-0.7 0.1-2-0.2-3.3q-0.9-4.2-1.8-8.8c-2.6-12.6-4.2-22.8-3.7-22.9 0.5-0.1 3 10 5.5 22.5q0.9 4.7 1.7 8.9c0.2 1.3 0.7 2.8-0.2 4.3-0.4 0.8-1.3 1.3-2 1.3-0.8 0.1-1.4 0-1.9 0-4.4-0.5-7-0.9-7-1.2z"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m284.8 194.6c-0.5 1-4.2-0.1-8.7-0.3-4.5-0.3-8.3 0.5-8.7-0.6-0.2-0.5 0.6-1.4 2.2-2.1 1.6-0.8 4-1.4 6.7-1.3 2.7 0.2 5.1 1 6.6 1.9 1.5 1 2.2 1.9 1.9 2.4z"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m328.4 207.4c-0.6 0.8-4.2-0.5-8.6-1.1-4.4-0.6-8.1-0.3-8.5-1.2-0.1-0.4 0.7-1.1 2.3-1.7 1.5-0.5 4-0.8 6.6-0.4 2.6 0.3 4.9 1.2 6.3 2.2 1.5 0.9 2.1 1.8 1.9 2.2z"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m232.7 246.2c-0.1 0.5-19.7 1.9-17.2-17.1 2.6-19.1 20.2-10.6 20.7-10.3 0 0-3.4 26.9-3.5 27.4z"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m227.1 239.1c-0.6 0.3-1.8 0.6-3.1 0.1-2.6-1.2-4.1-5.1-3.7-8.9 0.2-2 0.9-3.8 1.8-5.2 0.9-1.4 2.4-2.5 3.9-2.5 0.7 0.1 1.4 0.3 1.8 0.8 0.4 0.4 0.5 0.9 0.6 1.3 0 0.8-0.4 1.1-0.4 1-0.1 0 0-0.4-0.2-0.9-0.1-0.6-0.7-1.3-1.8-1.2-1 0-2.1 0.9-2.8 2.2-0.8 1.3-1.4 2.9-1.6 4.6-0.4 3.5 0.9 6.9 2.8 7.9 1 0.5 1.9 0.5 2.5 0.3 0.6-0.2 0.9-0.5 1-0.4 0 0.1-0.1 0.5-0.8 0.9z"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m285.7 258c-1.4-0.7-3.3-2-4.5-4.1-1.4-2.1-1.8-4.3-2-5.9-0.2-1.5-0.1-2.4 0.1-2.5 0.2 0 0.5 0.9 1 2.3 0.4 1.4 1 3.4 2.1 5.2 2.4 3.8 6 5.3 5.7 5.7 0 0.2-1 0.1-2.4-0.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m213.6 185.5c4.6-6.3 6.3-14.3 9.2-21.6 2.8-7.3 7.7-14.7 15.4-16.7l0.1 0.1c6.9-2.1 15-1.3 20.1 3.8 2.2-9.9 11.7-16.9 21.6-18.6 9.9-1.6 25.3 1.3 34.3 5.9 6.9 3.6 13.3 10.2 21 19.7 3.2 4 6.1 8.2 8.6 12.7l6.1 26.8-8.5 13c-0.5 0.9-1.1 1.8-1.7 2.6l-9.2 28.1c0.3-7.8 3.4-35.1 3.7-43-12-1.6-22.5-7.5-29.8-17.3-3.9-5.1-6.7-11.4-12.2-14.7-7-4.4-16.1-2.5-24.1-0.5l0.4-0.3c-4.3 1.5-8.2 3.8-11.6 6.8 0.4 15.6-2.7 31.3-8.9 45.6-1 2.2-3.4 6.6-5.6 7.2-4.5 1.3-5.2-3.2-7.6-5.8-1.7-1.9-4.5-2.3-7.6-2.6-1.4-4.9-2.5-13.1-3.4-20.3-2.7 0.5-5.5 0.5-8.1-0.2q1.5-2.9 3-5.7c-1.1 0.6-2.3 1.2-3.6 1.2-1.3 0.1-2.7-0.5-3.1-1.7-0.6-1.5 0.5-3.1 1.5-4.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m266.8 155.1c0.1 0-1.2 0.6-3 2.3-1.8 1.6-3.9 4.6-5.1 8.8-0.7 2.1-1.2 4.5-1.4 7-0.2 2.6-0.3 5.4-0.4 8.3 0 2.9-0.1 6-0.6 9.2q-0.3 2.3-1.1 4.7c-0.5 1.6-1 3.3-2.4 4.5-1 1-2.7 1.4-4 1-1.4-0.4-2.6-1.2-3.4-2.3-1.6-2.3-1.8-5-2-7.4l0.6 0.1c-1.2 2.1-2.4 4-4 5.6-1.5 1.5-3.6 2.4-5.7 2.4-1 0-2-0.2-2.8-0.7-0.8-0.6-1.4-1.3-1.8-2.1-0.3-0.9-0.4-1.7-0.3-2.6 0.1-0.8 0.5-1.6 1.1-2.1l0.2 0.3c-2.3 2.3-4.7 3.4-6.4 4-0.8 0.3-1.4 0.4-1.9 0.5q-0.7 0.2-0.7 0.1 0 0 0.7-0.2c0.4-0.1 1.1-0.3 1.9-0.6 1.6-0.7 3.9-1.8 6.2-4.1l0.2 0.3c-1 0.9-1.2 2.7-0.5 4.2 0.3 0.7 0.8 1.4 1.6 1.8 0.7 0.5 1.6 0.7 2.5 0.7 1.9 0 3.9-0.9 5.3-2.3 1.6-1.5 2.7-3.4 3.8-5.5l0.5-0.8 0.1 1c0.2 2.3 0.5 4.9 1.9 7 0.8 1 1.8 1.7 3 2.1 1.2 0.3 2.6 0 3.5-0.9 1.2-1 1.7-2.6 2.2-4.2q0.7-2.3 1.1-4.6c0.5-3.1 0.5-6.2 0.6-9.1 0.1-2.9 0.2-5.7 0.5-8.3 0.2-2.6 0.8-5 1.4-7.1 1.4-4.3 3.6-7.3 5.4-8.9 1.9-1.7 3.2-2.1 3.2-2.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m350.6 190.2q0 0-0.3 0.1-0.3 0.2-0.7 0.5-0.5 0.3-1.2 0.6c-0.6 0.2-1.1 0.5-1.8 0.8-2.7 0.9-7 1.8-12.2 1-5.1-0.8-11.1-3.2-16.2-7.8-5.2-4.5-9.6-10.8-12.9-18-1.7-3.5-3.1-7.1-4.6-10.5-1.5-3.4-3.2-6.5-5.5-9.1-2.1-2.5-4.7-4.5-7.5-5.6-1.4-0.5-2.9-0.8-4.2-0.9-1.4 0-2.7 0.1-4 0.4-2.5 0.6-4.5 1.8-6.1 3-1.6 1.2-2.7 2.6-3.5 3.8-1.5 2.4-1.8 4.1-1.9 4q0 0 0.1-0.3 0.1-0.3 0.2-0.8c0.2-0.7 0.6-1.8 1.4-3.1 0.7-1.2 1.8-2.6 3.5-3.9 1.6-1.3 3.7-2.5 6.2-3.1 1.3-0.3 2.7-0.5 4.1-0.5 1.4 0.1 2.9 0.3 4.4 0.9 2.9 1.1 5.6 3.1 7.8 5.7 2.3 2.6 4 5.8 5.6 9.2 1.5 3.4 2.9 7 4.6 10.6 3.3 7 7.6 13.3 12.7 17.8 5 4.5 10.9 6.9 15.9 7.7 5.1 0.9 9.3 0.1 12-0.8 2.7-0.9 4-1.8 4.1-1.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m327.6 218c-0.6 0.6-3.6-2.3-8.3-2.9-4.6-0.6-8.3 1.4-8.7 0.8-0.3-0.3 0.4-1.3 2-2.2 1.6-0.9 4.3-1.7 7.1-1.3 2.9 0.3 5.3 1.7 6.5 3 1.3 1.3 1.7 2.4 1.4 2.6z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m323.6 226.7c-0.2 2-2.1 3.4-4.2 3.2-2.1-0.3-3.6-2.1-3.3-4.1 0.3-1.9 2.1-3.4 4.2-3.1 2.1 0.2 3.6 2 3.3 4z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m341.9 167.3c2 3.4 5.4 6.7 9.3 6.7 1.2 0 4.3-0.8 4.3-0.8 1.3 0.9 0.5 5.6-0.6 6.8-1.1 1.2-3.2 2.7-3.2 2.7 4.3 2.9 8.6 2.1 13.6 0.9-1.7 8.2-8.2 15.2-16.2 17.7-2.6 0.8-5.6 1-7.7-0.7-1.8-1.5-2.4-4-2.7-6.3-1.4-8.6-1.6-17.4-0.8-26z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m290.3 325.2c0 0 17.6 7.1 27.7 31.5 7 17.1 46.2 71.2 46.2 71.2l104.1 23.1 3.5 33.2-166.5-1.4-23.1-73.7z"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m225.1 278.7c30.2 11.9 71.7 28.6 71.7 28.6l-3.7 16.5 5.5 19.5-29.6 161.1 9.1 6.4-156.3 89.3c0 0-12.3-69.6-6.1-116.7 6.1-46.7 22.1-99.5 39.7-140.4 7.3-17.1 29.2-33.6 46.3-40.7l18.5-7.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m205.3 553.5q0.9-12 1.7-24.1c-1.8 1.7-4.2 2.8-6.7 2.9 3.9-3.7 7.3-7.9 10.3-12.4q-3.6 1.5-7.1 3c2.5-1.9 4.6-4.4 6-7.2-3.8-3-9.2-2.5-14-2-24.7 2.5-49.6 0.9-74.4-0.8-2-0.1-5.5-0.9-7.1-2.1 0 0-0.5-6.8 0.6-9.3 1.1-2.5 2.8-1.8 5.4-2.8 2.6-0.9 5.4-1.1 8.1-1.2 30.2-1.6 60.5 0.9 90.6 3.4 1.8 0.1 3.8 0.3 5.3 1.5 2.4 2 2.2 5.8 1.8 8.9q-2.3 16.9-4.6 33.8"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m296.8 336.8q0 0-0.2 1.5-0.2 1.7-0.6 4.3c-0.6 3.8-1.5 9.2-2.7 15.8-2.3 13.3-5.9 31.6-10.1 51.8-4.2 20.1-8.2 38.3-11.2 51.5-1.5 6.5-2.7 11.8-3.6 15.6q-0.6 2.6-1 4.2-0.4 1.5-0.5 1.5 0-0.1 0.3-1.5 0.3-1.6 0.8-4.3c0.8-3.8 1.9-9.1 3.3-15.7 2.8-13.3 6.7-31.4 10.9-51.5 4.2-20.2 7.9-38.5 10.4-51.7 1.3-6.6 2.3-11.9 3-15.7q0.5-2.7 0.8-4.3 0.3-1.5 0.4-1.5z"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m155.4 565.6q0-0.1 1-1 1-1 2.8-2.6c1.2-1.1 2.7-2.4 4.5-3.9 1.8-1.5 3.8-3.3 6.2-5.1 4.6-3.7 10.3-7.8 16.8-12.1 6.5-4.3 13.9-8.8 21.9-13 8-4.2 15.8-7.8 23-10.8 7.3-2.9 13.9-5.2 19.6-7 2.8-0.9 5.4-1.6 7.6-2.2 2.3-0.7 4.3-1.2 5.9-1.5q2.2-0.6 3.7-0.9 1.3-0.3 1.3-0.2 0 0-1.3 0.4-1.4 0.4-3.6 1.1c-1.6 0.4-3.6 0.9-5.8 1.6-2.2 0.7-4.8 1.5-7.6 2.4-5.6 1.9-12.2 4.3-19.4 7.2-7.2 3-15 6.6-22.9 10.8-8 4.2-15.3 8.6-21.9 12.9-6.5 4.2-12.2 8.3-16.9 11.9-2.4 1.8-4.4 3.5-6.2 4.9-1.9 1.5-3.4 2.8-4.7 3.8q-1.8 1.5-2.9 2.5-1 0.8-1.1 0.8z"
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m235.6 506.6c0.2 0.2-15 8.8-33.9 19.1-18.9 10.2-34.3 18.4-34.4 18.1-0.2-0.2 15-8.8 33.9-19.1 18.9-10.2 34.3-18.4 34.4-18.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m180.7 383.1c9.7 42 39.4 79.5 78.9 96.6-26.3-27.7-54.8-62.8-78.9-96.6z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m294.3 351.2c3.8 17.8 1 39.9-7.9 55.8l-2.3-4.6c3.2-13.4 7.7-37 10.2-51.2z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m377.4 775l-18.8 56.4c0 0 51 38 48.6 48.7l-110.6-32.4 25.6-89z"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m377.4 775l-18.8 56.4c0 0 51 38 48.6 48.7l-110.6-32.4 25.6-89z"
  }))))))))))))))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m325.4 816.6c2.2-0.5 4.7 2 4.8 4.3 0.2 2.3-2.5 4.6-4.8 4.5-2.4 0-4.3-2.3-4.2-4.6 0.1-2.3 2.3-4.3 4.6-4.2"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m296.6 847.7l2.9-8.9 105 34.4c0 0 4.3 3.6 2.7 6.9z"
  }))))))))))))))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m360.6 831.3c-0.2 0.6-3 0-6.1 1-3.2 0.9-5.3 2.8-5.7 2.4-0.5-0.2 1.3-3.2 5.1-4.3 3.9-1.1 6.9 0.5 6.7 0.9z"
  })))))))))))))))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m370.8 839.5c-0.1 0.6-2.7 0.8-5.2 2.6-2.5 1.7-3.7 4-4.2 3.8-0.6-0.1 0-3.3 3.1-5.4 3.2-2.2 6.4-1.5 6.3-1z"
  })))))))))))))))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m373.3 855.4c-0.5-0.1-0.5-3 1.8-5.5 2.2-2.6 5.1-3 5.2-2.5 0.2 0.5-1.9 1.6-3.8 3.7-1.8 2.1-2.6 4.4-3.2 4.3z"
  })))))))))))))))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m363.4 818c-0.3 0.5-2.6-1-5.7-1.7-3.1-0.8-5.8-0.4-5.9-1-0.2-0.5 2.7-1.8 6.3-0.9 3.7 0.8 5.7 3.3 5.3 3.6z"
  }))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m409.6 800.2l-2.3 59.3c0 0 59.5 22.3 60.2 33.3l-115.3-0.3-0.1-92.7z"
  }))))))))))))))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m371.2 854.6c2.1-1.1 5.1 0.6 5.9 2.8 0.8 2.2-1.2 5.1-3.4 5.7-2.3 0.5-4.8-1.1-5.3-3.3-0.5-2.3 1-4.8 3.3-5.4"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m352.2 892.5l0.4-9.4 110.3 3.9c0 0 5.2 2.2 4.6 5.8z"
  }))))))))))))))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m409.2 859c-0.1 0.5-2.9 0.8-5.7 2.6-2.8 1.7-4.2 4.1-4.7 3.9-0.6-0.1 0.3-3.5 3.7-5.6 3.4-2.1 6.8-1.5 6.7-0.9z"
  })))))))))))))))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m421.2 864c0.1 0.5-2.3 1.5-4.2 3.9-2 2.3-2.5 4.9-3.1 4.8-0.5 0.1-0.9-3.2 1.6-6.1 2.4-2.9 5.7-3.1 5.7-2.6z"
  })))))))))))))))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m428 878.5c-0.5 0.1-1.2-2.7 0.2-5.8 1.4-3.1 4.1-4.3 4.3-3.8 0.4 0.4-1.4 2.1-2.5 4.6-1.2 2.6-1.4 4.9-2 5z"
  })))))))))))))))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m408.2 845.4c-0.3 0.5-2.8-0.3-6-0.1-3.2 0.1-5.7 1.2-6 0.7-0.3-0.4 2.1-2.5 5.9-2.7 3.7-0.2 6.4 1.6 6.1 2.1z"
  }))))))))))))))))))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m271.6 509.5c0 0 138.1 35.9 155.3 59.8 14.4 20.2-61.6 226.8-61.6 226.8l-60-5.2 25.9-172.8-154.8-49.2 23.4-59.4z"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m281.5 541.9c0 0 141.2 34.3 155.5 58.6 6.6 11.4 2.2 48.8-0.2 66.4-1.7 11.9-26.7 178.1-26.7 178.1h-61l1.3-187.7-146.7-29.6c0 0-78.8 6-81.9-27.6l32.9-44.6 77.6-38.3z"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m270.7 537.5c0 0 0.7 0.2 2.1 0.6q2 0.5 5.9 1.6c5.3 1.5 13.1 3.7 23.1 6.5 10 2.8 22.2 6.2 36.4 10.4 14.1 4.3 30.1 9.3 47.5 15.9 8.7 3.2 17.7 6.9 27 11.1q3.4 1.5 7 3.1 3.5 1.7 6.8 3.9c2.3 1.4 4.5 3 6.5 4.8 1.9 1.8 3.8 3.9 5.1 6.4 4.8 21.7 1.9 45.3-1.7 69.5-1.5 12.2-3.5 24.6-5.3 37.3q-2.9 19.1-5.9 38.9c-3.9 26.4-8 53.8-12.2 81.8q-1.2 7.9-2.4 15.8v0.5h-0.5c-20.8-0.1-41.2-0.1-61-0.1h-0.5v-0.5c0.5-71.1 1-135.6 1.4-187.7l0.3 0.4c-43.8-9-79.5-16.2-104.2-21.2-12.3-2.6-21.9-4.5-28.5-5.9q-4.8-1-7.4-1.5c-1.7-0.4-2.5-0.6-2.5-0.6 0 0 0.9 0.1 2.5 0.5q2.6 0.5 7.5 1.4c6.5 1.3 16.1 3.2 28.5 5.6 24.7 5 60.4 12.1 104.3 20.9h0.3v0.4c-0.3 52.1-0.8 116.6-1.2 187.7l-0.5-0.5c19.8 0 40.2 0 61 0l-0.5 0.5q1.2-7.9 2.4-15.9c4.2-28 8.3-55.3 12.2-81.7q3-19.9 5.9-38.9c1.8-12.7 3.8-25.2 5.4-37.3q1.2-9.2 2.4-18c0.9-6 1.3-11.8 1.6-17.6q0.3-8.7 0-17.2-0.2-4.2-0.6-8.3c-0.3-2.8-0.3-5.6-1.6-7.9-1.2-2.4-3-4.4-4.9-6.2-2-1.8-4.1-3.3-6.3-4.7q-3.3-2.1-6.8-3.8-3.5-1.6-7-3.2-13.8-6.2-26.9-11.1c-17.3-6.7-33.3-11.7-47.4-16-14.1-4.3-26.4-7.8-36.3-10.6-10-2.9-17.7-5.1-23-6.7q-3.9-1.1-6-1.7c-1.3-0.4-2-0.7-2-0.7z"
  })))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m466.3 452.6c0.9-1.3 12.5-14.8 15.7-14.8 3.1 0 6.7 3.6 6.7 3.6 0 0 4.1-1.8 6.7-0.9 2.7 0.9 15.3 11.7 15.3 15.7 0 4 0 6.7 0 6.7 0 0 0.5 2.3 0 5.4-0.4 3.2-8.1 8.5-8.1 8.5h-43c0 0-8.3-5.5-7.2-10.7 1-5.2 13.9-13.5 13.9-13.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m488.7 441.4c0.1-0.1 1 0.5 2.7 1.5 1.8 1.2 4.2 2.7 7.1 4.5 0.8 0.5 1.6 0.9 2.4 1.6 0.7 0.7 1.4 1.6 1.7 2.7 0.4 1.1 0.3 2.2 0.4 3.3q0.1 1.7 0.2 3.5c0.2 4.7 0.5 9.8 0.7 15.2q0.1 1.3 0.1 2.5l0.1 0.4-0.5 0.1q-1.3 0.3-2.6 0.6l-0.1 0.1c-1.3-0.1-2.5-0.6-3.4-1.3-0.9-0.7-1.6-1.7-2.2-2.6-1.1-1.9-1.7-3.9-2.2-5.8-1-3.8-1.4-7.3-1.5-10.4l0.2 0.4q-4.6-1.9-7.5-3c-1.8-0.7-2.7-1.2-2.7-1.2 0-0.1 1 0.2 2.8 0.8q3 1.1 7.7 2.7l0.2 0.1v0.2c0.2 3 0.7 6.4 1.7 10.2 0.5 1.8 1.1 3.7 2.2 5.5 1 1.7 2.6 3.3 4.7 3.3h-0.1q1.3-0.3 2.6-0.6l-0.4 0.5q-0.1-1.2-0.1-2.4c-0.2-5.4-0.5-10.6-0.7-15.3q0-1.8-0.1-3.4c-0.1-1.2 0-2.2-0.3-3.1-0.3-1-0.8-1.8-1.5-2.4-0.6-0.6-1.5-1.1-2.2-1.6-2.8-1.9-5.1-3.5-6.9-4.7-1.6-1.2-2.5-1.8-2.5-1.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m459.6 475.3c0-0.1 1-0.2 2.8-0.4q3.2-0.2 7.9-0.6h0.1c2.6 0.6 5.6 1.2 8.9 1.6 1.6 0.2 3.4 0.4 5.2 0.4 1.7 0.1 3.7 0 4.7-1.3 0.6-0.7 0.7-1.7 0.7-2.7 0.1-0.9-0.1-1.9-0.1-3-0.1-0.8-0.6-1.6-1.2-2.2-0.6-0.7-1.4-1.2-2.1-1.6-3.2-1.8-6.5-1.8-9.3-1.6-2.8 0-5.2-1.1-6.1-2.5-0.9-1.3-0.8-2.3-0.8-2.3 0.1 0 0.2 0.9 1.1 2.1 1 1.2 3.1 2.1 5.8 1.9 2.7-0.2 6.3-0.3 9.7 1.6 0.9 0.4 1.7 1 2.4 1.7 0.7 0.7 1.4 1.6 1.5 2.9 0 0.9 0.2 2 0.2 3 0 1.1-0.2 2.3-1 3.3-0.7 0.9-1.7 1.3-2.7 1.6-1 0.2-2 0.2-2.9 0.1-1.8 0-3.6-0.2-5.2-0.4-3.4-0.5-6.4-1.2-9-1.8h0.1q-4.7 0.1-7.8 0.3c-1.9 0-2.9 0-2.9-0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m503.5 475.1c-0.3-0.1 1.5-3.5 3.4-7.8 2-4.3 3.7-7.7 4-7.6 0.2 0.1-1.1 3.7-3 8-2 4.4-4.2 7.6-4.4 7.4z"
  })))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m406 480.2c0-2.2 1.8-4 4-4.1l145.1-1.4 49.3-132.8c1.2-3.2 4.8-4.7 7.9-3.4 2.9 1.3 4.2 4.6 3.1 7.5l-50 140.3-155.4-2.1c-2.2 0-4-1.8-4-4z"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m191 315.9c18.3-16.4 42.7-1.7 51.8 9.3 9.2 10.9 50.5 96.4 50.5 96.4l83.8 19.8v42c0 0-99 0-110.9 0-11.8 0-87.7-103.3-87.7-103.3 0 0-5.8-47.7 12.5-64.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m377.1 445.5l18.1-1.5c0 0 0.4-6.7 4.4-9.1 4-2.4 3.6-7.6 5.9-7.2 2.4 0.4 4 0 4 0l15.1-12.7 12.7-8.3 9.9-2c0 0 5.9 1.6 0 7.2l-6.4 3.5-5.5 5.6 12.7-6.2c1.2-0.6 2.5-0.6 3.7-0.1 2.9 1.4 8.3 4.1 9.8 5.5 2 2 0 4 0 4l5.5 4.7c0 0 1.2 6.4-5.1 4.8l-5.2-1.2-6.7 6.7c0 0 23-4.7 24.6-3.9 1.5 0.8 3.5 4.3 0 7.5-3.6 3.2-17.5 2.4-20.7 5.6-3.1 3.1-24.1 22.3-29.3 23.5-5.1 1.2-47.5 11.5-47.5 11.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m467 428.9c-0.1 0.1-1.2-0.8-3.1-2.2-0.9-0.7-2.1-1.5-3.4-2.4q-0.9-0.6-2-1.3c-0.7-0.4-1.5-0.9-2.1-0.9-1.6 0.1-3.1 1.2-4.5 1.9-1.3 0.7-2.5 1.4-3.5 2-2.1 1.2-3.3 2-3.4 1.9-0.1-0.2 1-1.1 3-2.5 0.9-0.7 2.1-1.5 3.5-2.3q1-0.6 2.1-1.2c0.8-0.4 1.7-0.8 2.7-0.8q0.4 0 0.9 0.1 0.3 0.1 0.7 0.3 0.6 0.3 1.1 0.6 1.1 0.7 2.1 1.4c1.3 1 2.4 1.9 3.3 2.6 1.8 1.6 2.7 2.7 2.6 2.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m411.3 426.2c0.2 0.2-1.7 1.9-3.9 4-2.2 2.1-4 3.9-4.2 3.7-0.2-0.2 1.2-2.3 3.5-4.5 2.2-2.1 4.5-3.4 4.6-3.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m242.8 325.2c0 0 1.8 2 4.4 6.4 2.7 4.3 6.4 10.8 10.8 19.2 8.9 16.7 21.2 41 35.7 70.6l-0.3-0.2c24.7 5.8 53.2 12.5 83.9 19.7l0.4 0.1v0.4c0 13.5 0 27.6 0 42v0.5h-0.6c-1.5 0-3.3 0-5 0-33.4 0-65.3 0-94.2 0q-5.5 0-10.8 0c-0.4 0-0.8 0-1.4-0.1q-0.7-0.1-1.3-0.4c-0.9-0.4-1.6-0.9-2.3-1.4-1.5-1.1-2.8-2.2-4.1-3.4-5.1-4.6-9.5-9.6-13.8-14.4-8.5-9.7-16.1-19-22.9-27.6-13.6-17.2-24.3-31.3-31.6-41.1-3.6-5-6.5-8.8-8.4-11.4q-1.4-1.9-2.1-3-0.7-1-0.7-1 0 0 0.8 1 0.7 1 2.2 2.9c1.9 2.6 4.8 6.4 8.5 11.2 7.4 9.7 18.2 23.8 31.9 40.9 6.8 8.6 14.4 17.9 22.9 27.5 4.3 4.8 8.8 9.8 13.8 14.4 1.3 1.1 2.6 2.2 4 3.2 0.7 0.5 1.4 1 2.2 1.3 0.7 0.4 1.4 0.5 2.3 0.4q5.3 0 10.8 0c28.9 0 60.8 0 94.2 0 1.7 0 3.5 0 5 0l-0.5 0.5c0-14.4 0-28.5 0-42l0.4 0.5c-30.6-7.3-59.1-14-83.8-19.9h-0.2l-0.1-0.2c-14.3-29.6-26.5-54-35.3-70.8-4.4-8.4-8-14.9-10.6-19.3-1.3-2.1-2.3-3.8-3.1-4.9-0.7-1-1.1-1.6-1.1-1.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m231.8 318.4c-0.1 0.2-2.6-0.8-6.8-1.8-2.2-0.5-4.7-0.9-7.6-1.1-2.9-0.2-6-0.2-9.3 0-3.3 0.4-6.4 1-9.2 1.7-2.8 0.8-5.2 1.7-7.2 2.6-4 1.7-6.3 3.2-6.4 3-0.1 0 0.5-0.4 1.5-1.1 1-0.7 2.6-1.6 4.6-2.6 1.9-1 4.4-1.9 7.2-2.8 2.8-0.8 6-1.5 9.4-1.8 3.3-0.3 6.6-0.2 9.5 0 2.9 0.3 5.5 0.8 7.6 1.4 2.2 0.6 3.9 1.2 5 1.7 1.1 0.5 1.7 0.8 1.7 0.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m278 440.7c-0.2-0.1 1.7-4.8 5.7-9.7 3.9-5 8.1-8 8.2-7.7 0.2 0.2-3.6 3.5-7.4 8.3-3.9 4.8-6.2 9.3-6.5 9.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m275.5 427.8c-0.2-0.2 2.7-2.7 7.2-4.2 4.4-1.6 8.2-1.6 8.2-1.3 0.1 0.3-3.6 0.7-7.9 2.3-4.3 1.5-7.4 3.5-7.5 3.2z"
  })))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m340.8 655.6c-4.6 2-9.8 1.3-14.8 0.7-73.7-9.3-148.5-9.8-222.4-1.6l-14.8-4.7c-3.7-8 0.4-17.9 7.3-23.5 6.9-5.5 15.9-7.5 24.6-9.1 72.2-13.1 147.1-2.3 217 20.2 3.5 1.1 7.4 2.6 9 5.9 2.2 4.5-1.3 10.1-5.9 12.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m265.7 620.4q-0.1 0.1-0.5 0-0.6-0.1-1.4-0.2-1.9-0.3-5.1-0.7c-4.5-0.8-11-1.8-19.1-2.7-16.1-1.9-38.5-3.6-63.3-3-6.2 0.1-12.2 0.4-18.1 0.9-5.8 0.4-11.4 0.7-16.8 1.2q-1 0.1-2.1 0-0.9-0.2-1.9-0.1c-1.2 0-2.5 0.3-3.7 0.5q-3.8 0.8-7.3 1.6c-4.6 1-8.9 2.1-12.8 3.4-7.7 2.5-13.5 5.6-17.3 8.1-1.9 1.2-3.3 2.3-4.2 3q-0.7 0.5-1.1 0.8-0.4 0.3-0.4 0.3 0 0 0.3-0.4 0.4-0.3 1-0.9c0.9-0.8 2.3-1.9 4.2-3.2 3.7-2.6 9.6-5.8 17.3-8.4 3.9-1.3 8.2-2.5 12.8-3.6q3.6-0.7 7.3-1.5c1.2-0.3 2.5-0.6 3.9-0.7 0.7 0 1.4 0 2 0.1q1 0.1 2 0c5.3-0.5 10.9-0.8 16.8-1.3 5.8-0.5 11.9-0.8 18.1-0.9 24.8-0.6 47.3 1.2 63.4 3.3 8.1 1.1 14.6 2.2 19 3.1q3.3 0.6 5.2 0.9 0.8 0.2 1.3 0.3 0.5 0.1 0.5 0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m87.4 484.4l139.8 5c5.4 0.2 9.5 5 8.8 10.3l-13.8 157.2h-26.9l17.2-142.8c0.2-1.7-1.1-3.3-2.8-3.4l-119.1-4.1z"
  }))))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m765 893h-19.1l-41.1-392.7v-4.1h18.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m306.8 496.2h18.7v4.2l-38.3 392.4h-19.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m306.8 496.2c0 0 0 0.7-0.1 2q-0.2 2.1-0.6 6c-0.5 5.3-1.2 13.1-2.1 23-2 20-4.7 48.9-8.2 84.7-6.9 71.5-16.5 170.6-27.3 281l-0.5-0.6c6 0 12.4 0 18.9 0q0.2 0 0.3 0l-0.5 0.5c18.1-184.4 33.5-340.5 38.6-392.4 0-2 0-3.1 0.1-4.2l0.1 0.1c-6.4 0-11 0-14.1-0.1q-2.3 0-3.4 0-1.2 0-1.2 0 0 0 1.1-0.1 1.2 0 3.4 0c3.1 0 7.8 0 14.2-0.1h0.1v0.2c0 1.1 0.1 2.2 0.1 4.2-5.1 51.9-20.2 208.1-38 392.5v0.5h-0.5q-0.1 0-0.3 0c-6.5 0-12.9 0-18.9 0h-0.5v-0.6c10.9-110.5 20.7-209.7 27.7-281.3 3.6-35.8 6.5-64.6 8.5-84.6 1-9.9 1.8-17.6 2.3-22.8q0.4-3.9 0.6-5.9 0.2-2 0.2-2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m796 500.3h-534.1v-16.9h534.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m739.1 500.3c0 0.3-106.4 0.5-237.7 0.5-131.3 0-237.7-0.2-237.7-0.5 0-0.3 106.4-0.5 237.7-0.5 131.3 0 237.7 0.2 237.7 0.5z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderDevelop);
export default __webpack_public_path__ + "static/media/under-develop.9f830508cdb71e0b2b21229b9d220076.svg";
export { ForwardRef as ReactComponent };